module.exports = __webpack_public_path__ + "img/city_seal.da7d6356.png";